import { ImportExport } from "@mui/icons-material";
import {
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DEFAULT_ELEVATION } from "lib/global";
import { useEffect, useState } from "react";
import EditFormControl from "./form/EditFormControl";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { useCallback } from "react";

const SortableContent = SortableContainer(({ children }) => {
  return <TableBody>{children}</TableBody>;
});

const SortableItem = SortableElement(
  ({
    row = {},
    index = 0,
    selected = {},
    columns = [],
    self = {},
    textColor,
    onSelect = () => {},
  }) => {
    return (
      <TableRow
        className={
          Boolean(selected?.id === row?.id) && Boolean(row?.id)
            ? "bg-primary bg-opacity-30"
            : ""
        }
        hover
        onClick={() => {
          onSelect(row, index);
        }}
      >
        {columns.map((column, columnIndex) => (
          <TableCell
            key={columnIndex}
            className={`text-13 text-${textColor} ${column?.cellCSS ?? ""}`}
            align={column?.align ?? "left"}
          >
            {/* <LazyLoad> */}
            {column?.cell
              ? column.cell(row, index, self)
              : row?.[column?.selector ?? ""]}
            {/* </LazyLoad> */}
          </TableCell>
        ))}
      </TableRow>
    );
  }
);

export const COUNT_PER_PAGE = 8;

export default function CustomDragTable({
  data = [],
  // label, selector, cell, sortable: 'no',cellCSS, align, type: 'date' | 'number'
  columns = [],
  selected = {},
  stickyHeader = true,
  height = 450,
  isFixed = true,
  className = "",
  defaultSortKeyIndex = -1,
  defaultASC = true,
  toolbar = false,
  pageCount = COUNT_PER_PAGE,

  noHeader = false,
  size = "small",

  checkAll = false,

  textColor = "secondary",

  elevation = DEFAULT_ELEVATION,
  onSelect = () => {},
  onSelectAll = () => {},
  onSortEnd = () => {},
  ...props
}) {
  const [sortKey, setSortKey] = useState(
    defaultSortKeyIndex >= 0
      ? {
          index: defaultSortKeyIndex,
          column: columns?.[defaultSortKeyIndex] ?? {},
          asc: Boolean(defaultASC),
        }
      : {}
  );
  const [current, setCurrent] = useState(data);
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: data?.length,
  });

  const isPage = pagination.pageCount > 1;
  const pagedData = isPage
    ? current.slice(
        (pagination.page - 1) * pageCount,
        pagination.page * pageCount
      )
    : current;

  const handlePage = (e, v) =>
    setPagination((s = {}) => ({ ...(s ?? {}), page: v }));

  const handleSortKey = (columnIndex = 0, column = {}) => {
    setSortKey((s = {}) => ({
      index: columnIndex,
      column: column,
      asc: s?.index === columnIndex ? !Boolean(s?.asc ?? false) : false,
    }));
  };

  const handleSort = (a, b) => {
    const aValue = sortKey?.column?.sortValue
      ? sortKey?.column?.sortValue(a)
      : a?.[sortKey?.column?.selector ?? ""];
    const bValue = sortKey?.column?.sortValue
      ? sortKey?.column?.sortValue(b)
      : b?.[sortKey?.column?.selector ?? ""];
    const formattedValue = {
      a: aValue,
      b: bValue,
    };
    if (Boolean(sortKey?.asc)) {
      return formattedValue.a > formattedValue.b ? -1 : 1;
    } else {
      return formattedValue.a < formattedValue.b ? -1 : 1;
    }
  };

  const handleDragSort = useCallback(({ oldIndex, newIndex }) => {
    onSortEnd(oldIndex, newIndex);
    //eslint-disable-next-line
  }, []);

  // const handleSort = (a, b) => {
  //   const aValue = String(
  //     sortKey?.column?.cell
  //       ? renderToString(sortKey?.column?.cell(a))
  //       : a?.[sortKey?.column?.selector] ?? ""
  //   ).toLowerCase();
  //   const bValue = String(
  //     sortKey?.column?.cell
  //       ? renderToString(sortKey?.column?.cell(b))
  //       : b?.[sortKey?.column?.selector] ?? ""
  //   ).toLowerCase();
  //   console.log(aValue, bValue, "value");
  //   const formattedValue = {
  //     a: aValue,
  //     b: bValue,
  //   };
  //   if (sortKey?.column?.type === "date") {
  //     formattedValue.a = dmy2ymdhis(aValue);
  //     formattedValue.b = dmy2ymdhis(bValue);
  //   }
  //   if (isDMY(aValue)) {
  //     formattedValue.a = dmy2ymdhis(aValue);
  //   }
  //   if (isDMY(bValue)) {
  //     formattedValue.b = dmy2ymdhis(bValue);
  //   }
  //   if (isDMYHIS(aValue)) {
  //     formattedValue.a = dmyhis2ymdhis(aValue);
  //   }
  //   if (isDMYHIS(bValue)) {
  //     formattedValue.b = dmyhis2ymdhis(bValue);
  //   }

  //   if (
  //     sortKey?.column?.type === "number" ||
  //     !isNaN(Number(aValue)) ||
  //     !isNaN(Number(bValue))
  //   ) {
  //     formattedValue.a = toNumber(aValue);
  //     formattedValue.b = toNumber(bValue);
  //   }

  //   if (Boolean(sortKey?.asc)) {
  //     return formattedValue.a > formattedValue.b ? -1 : 1;
  //   } else {
  //     return formattedValue.a < formattedValue.b ? -1 : 1;
  //   }
  // };

  useEffect(() => {
    if (
      (Boolean(data?.length > 0) ||
        (Boolean(data?.length === 0) && Boolean(current?.length > 0))) &&
      !Boolean(sortKey?.column?.sortable === "no")
    ) {
      setCurrent(() => data?.sort(handleSort));
      setPagination({
        page: 1,
        pageCount: Math.ceil(data.length / pageCount),
      });
    }
    // eslint-disable-next-line
  }, [data, sortKey]);

  return (
    <div>
      <Paper elevation={elevation}>
        {Boolean(toolbar) && toolbar}
        <TableContainer
          className={`${className} overflow-auto scroll-thumb`}
          style={{
            width: "100%",
            height: height,
            // ...(Boolean(isFixed)
            //   ? {
            //       minHeight: height,
            //     }
            //   : {}),
          }}
        >
          <Table
            stickyHeader={stickyHeader}
            style={{ width: "100%", cursor: "pointer" }}
            size={size}
            sx={{ minWidth: 700 }}
          >
            {!noHeader && (
              <TableHead>
                <TableRow>
                  {columns.map((column, columnIndex) => (
                    <TableCell
                      className={`py-4 ${
                        column?.selector === "checkbox" && "w-2"
                      }`}
                      key={columnIndex}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        title={column.label}
                      >
                        {column?.selector === "checkbox" ? (
                          <EditFormControl
                            type="checkbox"
                            value={checkAll}
                            onChange={onSelectAll}
                          />
                        ) : (
                          <span className="text-xs">{column.label}</span>
                        )}

                        {column?.sortable !== "no" &&
                          column?.selector !== "actions" &&
                          column?.selector && (
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleSortKey(columnIndex, column);
                              }}
                            >
                              <ImportExport
                                color={
                                  columnIndex === sortKey?.index
                                    ? sortKey.asc
                                      ? "primary"
                                      : "error"
                                    : "inherit"
                                }
                              />
                            </IconButton>
                          )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            )}
            <SortableContent
              onSortEnd={handleDragSort}
              axis="y"
              lockAxis="y"
              lockToContainerEdges={true}
              helperClass="helperContainerClass"
              useDragHandle={true}
            >
              {Boolean(pagedData?.length) ? (
                (pagedData ?? []).map((row, index, self) => {
                  return (
                    <SortableItem
                      key={index}
                      index={index}
                      selected={selected}
                      row={row}
                      columns={columns}
                      textColor={textColor}
                      self={self}
                      onSelect={onSelect}
                    />
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={columns?.length ?? 1} align="center">
                    <span className="text-13">No Data</span>
                  </TableCell>
                </TableRow>
              )}
            </SortableContent>
          </Table>
        </TableContainer>
        {isPage && (
          <div className="py-3 flex justify-center">
            <Pagination
              count={pagination?.pageCount}
              page={pagination?.page}
              onChange={handlePage}
              variant="contained"
              shape="rounded"
              color="primary"
            />
          </div>
        )}
      </Paper>
    </div>
  );
}
